import { GpsFix } from '@customer/store/apis/assetsApi';
import { setGpsFix } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import SingleSelectFilter from './SingleSelectFilter';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';

const useGpsFixOptions = (): DropdownItemProps<GpsFix>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.keys(GpsFix).map((key: string) => {
      const value = GpsFix[key as keyof typeof GpsFix];
      return {
        key: value,
        value,
        stringValue: value,
        label: t(`filters.GpsFix.${key}`),
      };
    });
  }, [t]);
};

export const GpsFixFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownElement>) => {
  const { t } = useTranslation();

  return (
    <SingleSelectFilter<GpsFix>
      filterName="gpsFix"
      label={label ?? t('GpsFix')}
      elementRef={elementRef}
      action={setGpsFix}
      useItemsHook={useGpsFixOptions}
    />
  );
};

export default GpsFixFilter;
